export default {
    name: 'en',
    messages: {
        _default: field => `The value of ${field} is incorrect.`,
        after: (field, [target]) => `${field} must appear after ${target}.`,
        alpha: field => `${field} can only contain alphanumeric characters.`,
        alpha_dash: field =>
            `${field} can contain alphanumeric characters (A-Z a-z), numbers (0-9), dashes (-) and underscores (_).`,
        alpha_num: field => `${field} can only contain alphanumeric characters.`,
        alpha_spaces: field => `${field} can only contain characters and spaces.`,
        before: (field, [target]) => `${field} must appear before ${target}.`,
        between: (field, [min, max]) => `${field} must have a value between ${min} and ${max}.`,
        confirmed: (field, [confirmedField]) => `${field} is different from ${confirmedField}.`,
        credit_card: field => `Filled ${field} incorrectly.`,
        date_between: (field, [min, max]) => `${field} must have a value between ${min} and ${max}.`,
        date_format: (field, [format]) => `${field} must have a value in the format ${format}.`,
        decimal: (field, [decimals = '*'] = []) =>
            `${field} can only contain numeric characters and decimal points${!decimals || decimals === '*' ? '' : decimals
            }.`,
        digits: (field, [length]) => `The ${field} field can only contain numeric characters and must be ${length}.`,
        dimensions: (field, [width, height]) =>
            `${field} should have width ${width} pixels and height ${height} pixels.`,
        email: field => `${field} is in the wrong format.`,
        excluded: field => `${field} must contain a valid value.`,
        ext: field => `${field} must be a file.`,
        image: field => `The ${field} field must be an image.`,
        included: field => `${field} must be a value.`,
        ip: field => `${field} must be a valid IP address.`,
        max: (field, [length]) => `${field} can not have more than ${length} characters.`,
        max_value: (field, [max]) => `${field} must be less than or equal to ${max}.`,
        mimes: field => `${field} must contain the appropriate file type.`,
        min: (field, [length]) => `${field} must contain at least ${length} characters.`,
        min_value: (field, [min]) => `${field} must be greater than or equal to ${min}.`,
        numeric: field => `${field} can only have numeric characters.`,
        regex: field => `${field} is formatted incorrectly.`,
        required: field => `${field} must not be left blank`,
        requiredTrim: field => `${field} must not be left blank`,
        date_required: field => `${field} must not be left blank`,
        size: (field, [size]) => `${field} can only contain a file smaller than ${formatFileSize(size)}.`,
        url: field => `${field} is not a valid URL.`,
        notSelectParent: field => `Father quota not selected.`,
        forceSelection: field => `${field} is incorrect. Please select ${field} in the list`,
        selectionAccount: field =>
            `${field} is not yet in the implicit account category. Please go to System\\\\Options\\\\General Options\\\\Accounts, Uncheck Account Restrictions when importing documents.`,
        emailMultiple: field => `Invalid ${field} address.`,
        taxCode: field => `Invalid tax code.`,
        phoneEmail: field => `${field} is in the wrong format.`,
        phone: field => `${field} is in the wrong format.`,
        requiredNumber: field => `${field} must not be left blank.`,
        requiredNumberMore0: field => `${field} must be greater than 0.`,
        requiredIsNumber: field => `${field} is in the wrong format.`,
        positiveNumber: field => `${field} is not entered in less than 1.`,
        validateFromDate: 'From the date must be less than or equal to the date',
        validateToDate: 'To date must be greater than or equal to the date',
        ValidateRole: 'You do not have the permissions to perform this function.',
        ValidateEditOrganizationRole: 'You do not have permission to edit the organizational structure. Please contact an admin user to be granted permission.',
        validateDateRange: field => `Exports must not exceed ${field} days.`,
        validateDateRange3Month: 'Export invoices should not exceed 3 months.',
        validateDateRange1Year: 'Export invoices should not exceed 1 year.',
        prefixemail: field => `Email format can not exist more than 1 character @`,
        specialemail: field =>
            `The program only allows saving emails containing characters: from A to Z, from 0 to 9, periods, horizontal dashes and underscores`,
        charactertext: field => `You must not enter special characters &lt;,&gt;,...`,
        customRequired: field => `${field} must not be left blank.`,
        invalidWebsite: field => `Invalid lookup website link`,
        link: field => `Invalid lookup website link`,
        containData: field => `${field} does not exist in the list`,
        autocompleteCombobox: field => `${field} does not exist in the list`,
        taxcodeWorking: field => 'Please enter an account with the tax code that matches the tax code of the unit you are working for.',
        identityNumberWorking: field => 'Please enter an account with the tax code/identity number matching the tax code/identity number of the unit you are working for.',
        requiredNumberLess0: field => `${field} must be less than 0.`,
        templateNo: field => 'Enter the invoice model number according to Decree 123, Decree 70',
        seriesWithoutCode: field =>
            `Enter the series of the invoice without code according to Decree 123, Decree 70`,
        validateStartDate: 'The start date must be less than or equal to the end date',
        validateEndDate: 'The end date must be greater than or equal to the start date',
        rangeDateDuplicate: field => 'Time periods cannot overlap',
        excessiveLength: field => `${field} cannot be more than 1000 days.`,
        excessiveLength1: field => `${field} cannot be more than 1000 days from the invoice date.`,
        validateMaxLengthStick: 'Only a maximum of 10 labels can be selected for 3 filters Sticker 1, Sticker 2, Sticker 3.',
        validateExistList: field => `${field} does not exist in the list`,
        identificationNumber: field => 'Invalid personal identification number',
        taxCodeOrIdentification: field => `Invalid ${field}`,
        validateMinDate: (minDate) => `From date must be greater than or equal to ${minDate}`,
        sameasemail: field => `${field} must be different from the old email address`
    }
};